import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {useSuiContext} from '@s-ui/react-context'
import IconCheckSmall from '@adv-mt/mt-svg-icons/lib/CheckSmall.js'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1} from '@adv-mt/ui/typography'

import {BASE_CLASS} from '../config.js'

const HIGHLIGHT_PARAMS = {highlightStart: '<strong>', highlightEnd: '</strong>'}

const FinancingClaims = ({literalKeys}) => {
  const {i18n} = useSuiContext()

  if (literalKeys.length === 0) return null

  return (
    <ul className={`${BASE_CLASS}-claims`}>
      {literalKeys.map(key => (
        <li className={`${BASE_CLASS}-claimsItem`} key={key}>
          <Icon intent={ICON_INTENTS.PRIMARY} size={ICON_SIZES.MD}>
            <IconCheckSmall size={ICON_SIZES.MD} />
          </Icon>
          <Body1>{htmlStringToReactElement(i18n.t(key, HIGHLIGHT_PARAMS))}</Body1>
        </li>
      ))}
    </ul>
  )
}

FinancingClaims.displayName = 'FinancingClaims'

FinancingClaims.propTypes = {
  literalKeys: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default FinancingClaims
